Namespace 'CemSurveys.Views'

class CemSurveys.Views.SurveyAnswerLinkView extends Backbone.View
  template: JST['backbone/templates/surveys/survey_answer_link']

  initialize: ({@linkGeneratorUrl}) ->

  render: ->
    @answerLink()
    @

  answerLink: ->
    @_setWaitCursor()
    $.ajax
      type: 'POST'
      url: @linkGeneratorUrl
      complete: => @_unsetWaitCursor()
      success: (response) => @_renderModal response

  _renderModal: ({survey_name, url}) ->
    @$el.html @template
      surveyName: survey_name
      url: url
    @$el.find('.modal').modal()

  _setWaitCursor: ->
    $('body').css 'cursor', 'progress'

  _unsetWaitCursor: ->
    $('body').css 'cursor', 'default'
